import styled from 'styled-components'

import { Container, Card } from 'semantic-ui-react'
import { BodyContainer } from '../../pages/main_page/components/style'

type NewsProjectNameProps = {
    $color: string
}

export const NewsProjectName = styled.span<NewsProjectNameProps>`
    color: ${({ $color }) => $color};
    line-height: 1.733em;
`

export const NewsCard = styled(Card)`
    &&& {
        font-size: 18px;
        border-radius: .2rem;
        margin: 0.2em 0.5em;

        &:first-child {
            &&&>.content {
                padding: 1em 0.5em;
            }
            & .circle.icon {
                color: #009846;
            }
        }
        &:not(:first-child) {
            & .circle.icon {
                color: rgba(0, 0, 0, 0.2);
            }
            box-shadow: none;
            background-color: inherit;
        }
    }

    &&&>.content {
        padding: .5em;
    }
    & .description {
        line-height: 1.2em;
        margin-left: 1.2em;
    }
    
    & span {
        font-size: 16px;
    }

    & .ui.grid {
        & .row {
            padding: 0.5em 0.5em 0.7em 0.5em;
            & .right.aligned.column span {
                margin-left: 0.5em;
                color: rgba(0,0,0,.5);
            }
            & .description a {
                margin-left: 1em;
                /* text-decoration: underline; */
            }
            & a:not(:hover) {
                color: rgba(0,0,0,.5);
            }
        }
    }
    @media (max-width: 767px) {
        &&&& {
            margin: 1em 0;
            & .container {
                margin: 0 !important;
            }
        }
        & .ui.stackable.grid>.row>.column{
            padding: .5em !important;
        }
        & .ui.stackable.grid>.row>.column:last-child{
            padding-top: 0 !important;
        }
    }
`

export const NewsContainer = styled(BodyContainer)`
`
export const MoreNews = styled.p`
    padding-top: 1em;
    text-align: right;
    &>a{
        color: rgba(0,0,0,.5);
        font-size: 18px;
    }
`
export const NewsDate = styled.span`
    @media (max-width: 767px) {
        float: left;
    }
`